document.querySelectorAll('.hero-carousel').forEach((carousel) => {
  const slides = Array.from(carousel.querySelectorAll('.hero-carousel__slide'));
  const dots = Array.from(carousel.querySelectorAll('.hero-carousel__dot'));
  const prevBtn = carousel.querySelector('.hero-carousel__arrow--prev');
  const nextBtn = carousel.querySelector('.hero-carousel__arrow--next');
  if (slides.length < 2) return;

  const speed = parseFloat(carousel.dataset.autoplay || '3.5') * 1000;
  let current = slides.findIndex((s) => s.classList.contains('is-active'));
  if (current < 0) current = 0;
  let timer = null;

  function goTo(index) {
    const next = (index + slides.length) % slides.length;
    if (next === current) return;

    slides[current].classList.remove('is-active');
    slides[current].classList.add('is-leaving-left');
    slides[next].classList.add('is-active');
    slides[next].classList.remove('is-leaving-left');

    if (dots[current]) dots[current].classList.remove('is-active');
    if (dots[next]) dots[next].classList.add('is-active');

    setTimeout(() => slides[current].classList.remove('is-leaving-left'), 650);
    current = next;
  }

  function start() {
    stop();
    timer = setInterval(() => goTo(current + 1), speed);
  }
  function stop() {
    if (timer) clearInterval(timer);
    timer = null;
  }
  function restart() {
    stop();
    start();
  }

  nextBtn && nextBtn.addEventListener('click', () => { goTo(current + 1); restart(); });
  prevBtn && prevBtn.addEventListener('click', () => { goTo(current - 1); restart(); });
  dots.forEach((dot) => {
    dot.addEventListener('click', () => { goTo(parseInt(dot.dataset.index, 10)); restart(); });
  });

  // Swipe / drag support
  let startX = 0;
  let isDragging = false;
  const track = carousel.querySelector('.hero-carousel__track');

  track.addEventListener('pointerdown', (e) => {
    isDragging = true;
    startX = e.clientX;
    stop();
  });
  track.addEventListener('pointerup', (e) => {
    if (!isDragging) return;
    isDragging = false;
    const diff = e.clientX - startX;
    if (diff > 50) goTo(current - 1);
    else if (diff < -50) goTo(current + 1);
    start();
  });
  track.addEventListener('pointerleave', () => {
    if (isDragging) { isDragging = false; start(); }
  });

  // Pause on hover, resume on leave
  carousel.addEventListener('mouseenter', stop);
  carousel.addEventListener('mouseleave', start);

  start();
});